import React, { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import uuid from "react-uuid";
import Button from "react-bootstrap/Button";
import Input from "../../../common/components/form/input";
import { updateQualityAttributeValueMarketAssignment } from "../../../common/services/markets/qualityAttributeValueMarketAssignmentService";
import {
  formatDateToISOString,
  formatDateToYYYYMMDD,
} from "../../../common/utils/dateUtils";

const MarketQualityAttributeAssignmentInputHandler = ({
  assignment,
  marketId,
  allowEdit,
  submitCallbackFunction,
  onClose,
}) => {
  const { t } = useTranslation(["markets"]);
  const [updateStartDate, setUpdateStartDate] = useState(
    assignment?.startDate ? formatDateToYYYYMMDD(assignment.startDate) : ""
  );
  const [updateEndDate, setUpdateEndDate] = useState(
    assignment?.endDate ? formatDateToYYYYMMDD(assignment.endDate) : null
  );

  const handleUpdate = useCallback(async () => {
    // Validate
    if (!updateStartDate) {
      toast.error(t("StartDateRequired"));
      return;
    }

    // Validate date range
    if (updateStartDate && updateEndDate && updateStartDate > updateEndDate) {
      toast.error(t("StartDateMustBeBeforeEndDate"));
      return;
    }

    try {
      // Prepare assignment for API update
      const updatedAssignment = {
        qualityAttributeValueId: assignment.qualityAttributeValueId,
        marketId: marketId,
        startDate: formatDateToISOString(updateStartDate),
        endDate: formatDateToISOString(updateEndDate),
        eventId: uuid(),
      };

      const result = await updateQualityAttributeValueMarketAssignment(
        updatedAssignment
      );

      if (submitCallbackFunction) {
        submitCallbackFunction(result || updatedAssignment);
      }

      toast.success(t("AssignmentUpdated"));

      if (onClose) {
        onClose();
      }
    } catch (error) {
      console.error("Error updating assignment:", error);
      toast.error(
        t("ErrorSaving") + " " + (error.response?.data || error.message)
      );
    }
  }, [
    t,
    marketId,
    assignment,
    updateStartDate,
    updateEndDate,
    submitCallbackFunction,
    onClose,
  ]);

  return (
    <div>
      <div className="mb-3">
        <div className="row">
          <div className="col">
            <Input
              type="date"
              value={updateStartDate}
              onChange={(e) => setUpdateStartDate(e.target.value)}
              label={t("StartDate")}
              disabled={!allowEdit}
            />
          </div>
          <div className="col">
            <Input
              type="date"
              value={updateEndDate || ""}
              onChange={(e) => setUpdateEndDate(e.target.value || null)}
              label={t("EndDate")}
              disabled={!allowEdit}
              min={updateStartDate || undefined}
            />
          </div>
        </div>
        {assignment?.qualityAttributeValue && (
          <div className="mt-2">
            <small className="text-muted">
              {t("QualityAttributeValue")}: {assignment.qualityAttributeValue}
            </small>
          </div>
        )}
      </div>
      {allowEdit && (
        <div className="mt-3">
          <Button variant="primary" onClick={handleUpdate}>
            {t("Save")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MarketQualityAttributeAssignmentInputHandler;
